module.exports = __webpack_public_path__ + "assets/img/naver_609.6f04bdc2.png";